import React from "react";
import Box from "@mui/material/Box";
import { HOUR_REM, rem, packLanes } from "./gridHelpers";

// One timeline column (a day or an entity). Owns the lane packing; block
// visuals belong to the caller's BlockComponent, which receives the packed
// item plus the grid geometry it needs to position itself.
function GridColumn({ items, highlight, hours, hourCount, bodyHeightRem, gridStartMin, columnMinWidthRem, BlockComponent, blockProps, innerRef, nowTopRem = null }) {
  const { placed, laneCount } = packLanes(items);
  return (
    <Box
      ref={innerRef}
      sx={{
        flex: 1,
        minWidth: rem(columnMinWidthRem),
        position: "relative",
        height: rem(bodyHeightRem),
        borderLeft: 1,
        borderColor: "divider",
        bgcolor: highlight ? "action.hover" : "transparent",
        scrollSnapAlign: "start"
      }}
    >
      {hours.slice(0, hourCount).map((h, i) => (
        <Box key={h} sx={{ position: "absolute", top: rem(i * HOUR_REM), left: 0, right: 0, borderTop: 1, borderColor: "divider", opacity: 0.5 }} />
      ))}
      {placed.map((item) => (
        <BlockComponent key={item.booking._id} item={item} gridStartMin={gridStartMin} laneCount={laneCount} {...blockProps} />
      ))}
      {nowTopRem !== null && (
        <Box
          sx={{
            position: "absolute",
            top: rem(nowTopRem),
            left: 0,
            right: 0,
            height: "0.125rem",
            mt: "-0.0625rem",
            bgcolor: "primary.main",
            pointerEvents: "none",
            "&::before": {
              content: '""',
              position: "absolute",
              left: "-0.25rem",
              top: "-0.1875rem",
              width: "0.5rem",
              height: "0.5rem",
              borderRadius: "50%",
              bgcolor: "primary.main"
            }
          }}
        />
      )}
    </Box>
  );
}

export default GridColumn;
